const t = {
  name: "TriangleLeft",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.5002 18.5807L15.5002 6.41943L7.89941 12.5001L15.5002 18.5807Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as TriangleLeft
};
